import * as $ from "jquery";
import { ModalPopup } from "./modalpopup";
import { FacultyScoreReport } from "./facultyscorereport";

interface InstructorItem {
    Name: string;
    InstructorID: number;
    Hilights: Array<string>;
    HasFooter: boolean;
    PhotoImage: string;
    HasPhoto: boolean;
    ScoreReportFilename: string;
    HasScoreReportFilename: boolean;
}

export class ScheduleCalender {
    selected: number;
    instructorList: Array<InstructorItem>;
    activeMonth: number;
    $calendar: JQuery;
    $thumbnails: JQuery;
    monthcount: number;
    facultyscorereport: FacultyScoreReport;

    constructor(instructorList: Array<InstructorItem>, activeMonth: number) {
        const self = this;
        self.instructorList = instructorList;
        self.activeMonth = activeMonth;
        self.selected = 0;
        self.$calendar = $(".calendar:not(.thumbnails) .montharea");
        self.$thumbnails = $(".calendar.thumbnails .montharea");
        self.monthcount = self.$calendar.length;
        self.facultyscorereport = new FacultyScoreReport();

        const $locationbutton = $("#location-button");
        const $instructorbutton = $("#instructor-button");

        /* ---- DIVIDER ---- */
        if ($locationbutton.length > 0 && $instructorbutton.length > 0) {
            $locationbutton.find("p:last-child").addClass("has-divider");
        }

        /* ---- LOCATION INFO ---- */
        if ($locationbutton.length > 0) {
            var popuplocation = new ModalPopup(
                $("#courselocation-modal"),
                $("#dialog-courselocation"),
                "Location Information",
            );

            // Open / close location modal
            $locationbutton.on("click", function () {
                popuplocation.show();
            });
        }

        /* ---- INSTRUCTOR INFO ---- */
        if ($instructorbutton.length > 0) {
            const $popup = $("#instructor-modal");
            const $dialoginstructor = $("#dialog-instructor");
            var popupinstructor = new ModalPopup($popup, $dialoginstructor);

            $dialoginstructor.on("click", ".score-report-img", function () {
                const $srbutton = $(this);
                const src = $srbutton.data("scorereport");
                const name = <string> $srbutton.data("name");
                $popup.hide();
                self.facultyscorereport.launchModal(src, name);
            });

            // Populate and open the instructor modal
            $instructorbutton.find(".instructor").on("click", function (e) {
                const i = $(this).index();
                const instructor = self.instructorList[i];

                const instructorImage =
                    "https://d27sndzb7hbxda.cloudfront.net/xmlupload/userphoto/" +
                    ($(this).data("photo"));

                // Set instructor image
                let img: string;
                if (instructor.PhotoImage == null) {
                    img =
                        "url('https://www.testmasters.net/images/faculty/photo_unavailable.png')";
                } else {
                    img = "url(" + instructorImage + ")";
                }

                // Set instructor title
                popupinstructor.setTitle(instructor.Name);

                // Get instructor image
                $popup.find("#instructor-image").css("background-image", img);

                const hilight = "<span class='score-report-img' data-name='" +
                    instructor.Name +
                    "' data-scorereport='" + "/xmlupload/scorereport/" +
                    instructor.ScoreReportFilename +
                    "'></span>";

                // Set instructor info
                const info = "<p>" + instructor.Hilights.join("</p><p>") +
                    hilight + "</p>";
                $popup.find("#instructor-details").html(info);

                popupinstructor.show();
            });
        }

        /* ---- CALENDAR INFO ---- */
        // Controls
        $(".next").on("click", function (e) {
            e.preventDefault();
            if (!$(this).hasClass("disabled")) {
                self.selectMonth(self.selected + 1);
            }
        });
        $(".prev").on("click", function (e) {
            e.preventDefault();
            if (!$(this).hasClass("disabled")) {
                self.selectMonth(self.selected - 1);
            }
        });

        // Thumbnails
        self.$thumbnails.on("click", function () {
            self.selectMonth(self.$thumbnails.index(this));
        });

        // Main Calendar
        self.selectMonth(self.activeMonth);
    }

    // Month Selection
    selectMonth(monthNo: number) {
        const self = this;

        // Prevent invalid month numbers
        if (monthNo < 0) {
            monthNo = 0;
        } else if (monthNo > self.monthcount - 1) {
            monthNo = self.monthcount - 1;
        }

        self.selected = monthNo;
        // Hide all inactive calendars
        self.$calendar.hide().slice(self.selected, self.selected + 1)
            .css("visibility", "visible").show();

        // Updated currently selected month thumbnail
        self.$thumbnails.removeClass("selected").slice(
            self.selected,
            self.selected + 1,
        ).addClass("selected");

        // Update the calendar controls based on available actions
        // Prev month button
        $(".calendar-container .prev").toggleClass("disabled", monthNo == 0);
        // Next month button
        $(".calendar-container .next").toggleClass(
            "disabled",
            monthNo >= self.monthcount - 1,
        );
    }
}
